import { render, staticRenderFns } from "./dots-separator.vue?vue&type=template&id=3b2cdbc3&scoped=true&"
import script from "./dots-separator.vue?vue&type=script&lang=js&"
export * from "./dots-separator.vue?vue&type=script&lang=js&"
import style0 from "./dots-separator.vue?vue&type=style&index=0&id=3b2cdbc3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2cdbc3",
  null
  
)

export default component.exports